import { render, staticRenderFns } from "./teoriakoulutus.vue?vue&type=template&id=448ff669&scoped=true&"
import script from "./teoriakoulutus.vue?vue&type=script&lang=ts&"
export * from "./teoriakoulutus.vue?vue&type=script&lang=ts&"
import style0 from "./teoriakoulutus.vue?vue&type=style&index=0&id=448ff669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ff669",
  null
  
)

export default component.exports